import React from 'react';
import { LinkedDestinationEntitlement } from '@css-xp/graphtypes/src/generated-types-new';
import { CloudChildProduct } from '@atlassian/cssxp-typescommon';

import { NoDataContentInTable } from '../../../no-data-content-table';
import { FormattedDate } from '../../../formatted';

interface Props {
  item: LinkedDestinationEntitlement | CloudChildProduct;
}

export const LastBilledDate = ({ item }: Props) => {
  if (item.trial) {
    if (item.trialStartDate) {
      return (
        <div data-testid="trial-date">
          <FormattedDate date={item.trialStartDate} />
        </div>
      );
    }
    return <NoDataContentInTable />;
  }
  return item?.latestPeriodStartDate ? (
    <div data-testid="last-period-start-date">
      <FormattedDate date={item.latestPeriodStartDate} />
    </div>
  ) : (
    <NoDataContentInTable />
  );
};
